// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"1a9a533b","319":"ca3519ae","693":"e1dacb8a","845":"5a53e2a1","983":"c605abb4"}[chunkId] + ".chunk.js";
};